export enum ErrorCodes {
  /** Exception migrating user in app client. Note: Feature branches cannot migrate users. */
  AUTH_MIGRATION_ERROR = 'ERR_AUTH_1',
}
